<template>
  <b-container fluid>
    <b-row class="mb-3">
      <b-col cols="12">
        <PageHeader :title="$cte('employee.title')" />
      </b-col>
    </b-row>
    <b-row class="font-poppins">
      <b-col xs="12" xl="6" class="mb-3">
        <b-card>
          <template v-slot:header>
            <b-container fluid>
              <b-row>
                <b-col cols="12">
                  <div class="d-flex justify-content-between">
                    <div class="vertical-center ml-0 mr-0 width-max-content">
                      <div class="mb-0 custom-card-header-text">
                        {{ $cte("employee.permanentEmployee") }}
                      </div>
                    </div>
                    <div class="d-md-block text-right">
                      <b-button
                        variant="primary"
                        size="sm"
                        class="_p-2 mx-1 mb-1"
                        @click="newPermanentEmployee"
                      >
                        <i class="fal fa-user-plus d-inline d-md-none" style="font-size: 14px;"></i>
                        <span class="d-none d-md-inline">Új alkalmazott</span>
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </template>

          <EmployeeView
            v-if="getActiveCompany && getActiveCompany.id"
            :empty-list-string="'employee.emptyPermanentList'"
            :item-per-page="myPermanentEmployeeOptions.itemPerPage"
            :api-callback="myPermanentEmployeeOptions.apiCallback"
            :enable-pagination="myPermanentEmployeeOptions.enablePagination"
            :active-company-id="getActiveCompany.id"
            :show-exit="true"
          />
        </b-card>
      </b-col>

      <b-col xs="12" xl="6" class="mb-3">
        <b-card>
          <template v-slot:header>
            <b-container fluid>
              <b-row>
                <b-col cols="12">
                  <div class="d-flex justify-content-between">
                    <div class="vertical-center ml-0 mr-0 width-max-content">
                      <div class="mb-0 custom-card-header-text">
                        {{ $cte("employee.casualEmployee") }}
                      </div>
                    </div>
                    <div class="text-right">
                      <b-button
                        variant="primary"
                        size="sm"
                        class="_p-2 mx-1 mb-1"
                        @click="newCasualEmployee"
                      >
                        <i class="fal fa-user-plus d-inline d-md-none" style="font-size: 14px;"></i>
                        <span class="d-none d-md-inline">Új alkalmazott</span>
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </template>

          <EmployeeView
            v-if="getActiveCompany && getActiveCompany.id"
            :empty-list-string="'employee.emptyCasualList'"
            :item-per-page="myCasualEmployeeOptions.itemPerPage"
            :api-callback="myCasualEmployeeOptions.apiCallback"
            :enable-pagination="myCasualEmployeeOptions.enablePagination"
            :active-company-id="getActiveCompany.id"
            :show-exit="true"
          />
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import EmployeeView from "@/components/EmployeeView";
import Api from "api-client/index";
import PageHeader from "@/components/PageHeader";
import { mapGetters } from "vuex";

export default {
  name: "Employee",
  components: {
    PageHeader,
    EmployeeView,
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  data() {
    return {
      myPermanentEmployeeOptions: {
        itemPerPage: 10,
        apiCallback: Api.getPermanentEmployees,
        enablePagination: true,
        showExit: false,
      },
      myCasualEmployeeOptions: {
        itemPerPage: 10,
        apiCallback: Api.getCasualEmployees,
        enablePagination: true,
        showExit: false,
      },
    };
  },
  methods: {
    newPermanentEmployee() {
      this.$router.push(`/app/employee/create/${this.getActiveCompany.id}/FIX`);
    },

    newCasualEmployee() {
      this.$router.push(`/app/employee/create/${this.getActiveCompany.id}/TEMPORARY`);
    },
  },
};
</script>

<style scoped></style>
